module.exports = __webpack_public_path__ + "img/mostpopular.5235f3dc.png";